import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { LoadingPanel } from "../../LoadingPanel";
import { addNotificationWithTimeout } from '../../../app/addNotificationWithTimeout';
import { handleResponse } from '../../../app/handleResponse';
import { getCSRFToken } from '../../../app/getCSRFToken';
import {
    Grid,
    GridColumn as Column,
} from "@progress/kendo-react-grid";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Button } from "@progress/kendo-react-buttons";

import './TicketingWebsiteAlert.scss';

export const AdministratorTicketingWebsiteAlertLogs = (props) => {
    const dispatch = useDispatch();

    const [ticketingWebsiteAlertLogs, setTicketingWebsiteAlertLogs] = useState([]);
    const [ticketingWebsiteAlertLogCount, setTicketingWebsiteAlertLogCount] = useState(0);
    const [skipCount, setSkipCount] = useState(0);
    const [itemsPerPage, setItemsPerPage] = useState(1);
    const [areTicketingWebsiteAlertLogsLoading, setAreTicketingWebsiteAlertLogsLoading] = useState(true);
    const [loadingError, setLoadingError] = useState("");

    const [showDialog, setShowDialog] = useState(false);
    const [dialogContent, setDialogContent] = useState("");

    const ViewDialogCell = (props) => {  
        const content = props.dataItem[props.field];
        
        return (
            <td>
                {content ? <Button fillMode="link" type={"button"} onClick={() => viewDialog(content)}>View</Button> : ""}
            </td>
        );
    };

    const viewDialog = (content) => {
        setDialogContent(content);
        setShowDialog(true);
    }

    const getTicketingWebsiteAlertLogs = (newPageNumber) => {
        setAreTicketingWebsiteAlertLogsLoading(true);

        const dataItem = {
            ticketingWebsiteAlertKey: props.ticketingWebsiteAlertKey,
            pageNumber: newPageNumber,
        };
    
        fetch(`/api/administrator/ticketingwebsitealertlogs`,
            {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    "X-XSRF-TOKEN": getCSRFToken(),
                },
                body: JSON.stringify(dataItem),
            })
            .then(handleResponse)
            .then(result => {
                setAreTicketingWebsiteAlertLogsLoading(false);                
                setItemsPerPage(result.ticketingWebsiteAlertLogsPerPage);
                setSkipCount(result.ticketingWebsiteAlertLogsPerPage * (result.pageNumber - 1));
                setTicketingWebsiteAlertLogCount(result.totalTicketingWebsiteAlertLogCount);                
                setTicketingWebsiteAlertLogs(result.ticketingWebsiteAlertLogs);
            })
            .catch(error => {
                addNotificationWithTimeout(dispatch, "error", error.message);

                setAreTicketingWebsiteAlertLogsLoading(false);
                setLoadingError(error.message);
            });
    }

    const pageChange = (event) => {
        const newPageNumber = (event.page.skip / event.page.take) + 1;
        getTicketingWebsiteAlertLogs(newPageNumber);
    };

    useEffect(() => {
        if (props.ticketingWebsiteAlertKey) {
            getTicketingWebsiteAlertLogs();
        }
    }, []);

    return (
        <div>
            {areTicketingWebsiteAlertLogsLoading ? <LoadingPanel /> : (loadingError === "" ? (
                <>
                    <Grid
                        data={ticketingWebsiteAlertLogs}
                        dataItemKey={"ticketingWebsiteAlertLogKey"}
                        resizable={true}
                        skip={skipCount}
                        take={itemsPerPage}
                        total={ticketingWebsiteAlertLogCount}
                        pageable={true}
                        onPageChange={pageChange}
                        scrollable="none"
                    >
                        <Column field="dateCreated" title={"Date"} />
                        <Column field="elapsedTime" title={"Runtime"} />
                        <Column field="isAlertSuccessful" title={"Alert Successful"} />
                        <Column field="isEmailSentSuccessfully" title={"Email Successful"} />
                        <Column field="notes" title={"Notes"} cell={ViewDialogCell} />
                    </Grid>

                    {showDialog === false ? <></> :
                        <Dialog
                            title={"Notes"}
                            onClose={() => setShowDialog(false)}
                            width={"90vw"}
                        >
                            {dialogContent}
                        </Dialog>
                    }
                </>
            ) : <></>)
            }
        </div>
    );
}